import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-085915e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-text-center" }
const _hoisted_2 = { class: "tw-text-center" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenderMathQuestion = _resolveComponent("RenderMathQuestion")!
  const _component_RenderMathAnswer = _resolveComponent("RenderMathAnswer")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(_ctx.rowClass)
  }, [
    _createElementVNode("td", null, [
      _createVNode(_component_RenderMathQuestion, {
        "question-kind": _ctx.question.questionKind || 'text',
        question: _ctx.question.question || ''
      }, null, 8, ["question-kind", "question"])
    ]),
    _createElementVNode("td", _hoisted_1, [
      _createVNode(_component_RenderMathAnswer, {
        answer: _ctx.question.answer?.value || '',
        "answer-render-kind": _ctx.question.answerRender?.kind,
        "answer-render": _ctx.question.answerRender?.render?.answer,
        question: _ctx.question,
        formats: _ctx.answerFormats
      }, null, 8, ["answer", "answer-render-kind", "answer-render", "question", "formats"])
    ]),
    _createElementVNode("td", _hoisted_2, [
      (!_ctx.question.answer?.isCorrect && _ctx.question.answer)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createVNode(_component_RenderMathAnswer, {
              answer: _ctx.question.expectedAnswer || '',
              "answer-render-kind": _ctx.question.answerRender?.kind,
              "answer-render": _ctx.question.answerRender?.render?.correct,
              question: _ctx.question
            }, null, 8, ["answer", "answer-render-kind", "answer-render", "question"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}